import { init } from '@rematch/core';
import createLoadingPlugin from '@rematch/loading';
import user from './user';
import patient from './patient';
import sms from './sms';
import patientStatusLogs from './patientStatusLogs';
import patientCcmStatusLogs from './patientStatusLogs/ccm';
import patientHoldingStatusLogs from './patientStatusLogs/holdingStatus';
import comments from './comments';
import clinics from './clinics';
import discharge from './discharge';
import appointment from './appointment';
import orderConsumable from './orderConsumable';
import activity from './activity';
import doctor from './doctor';
import medicare from './medicare';
import interactiveTime from './interactiveTime';
import onboardingStatus from './onboardingStatus';
import compliance from './compliance';
import adherenceLast30Days from './adherence/last30DaysReport';
import clinicalMetrics from './clinicalMetrics';
import connect from './connect';
import servicePlans from './servicePlans';
import practiceOverview from './practiceOverview';
import adminPanelPatients from './adminPanelPatients';
import adminPanelUsers from './adminPanelUsers';
import adminPanelAgencyDoctors from './adminPanelAgencyDoctors';
import adminPanelClinics from './adminPanelClinics';
import adminPanelAgencies from './adminPanelAgencies';
import covid from './covid';
import ccmPatients from './ccm/patientsActivity';
import ccmPatientDetails from './ccm/patientDetails';
import clinicalEscalation from './clinicalEscalation';
import hospitalPrevention from './hospitalPrevention';
import clinicRunBookLogs from './clinicRunBookLogs';
import ccmInteractiveTime from './ccmInteractiveTime';
import manualInteractiveTime from './manualInteractiveTime';

const loadingPlugin = createLoadingPlugin();

const store = init({
  plugins: [loadingPlugin],
  models: {
    user,
    patient,
    doctor,
    sms,
    patientStatusLogs,
    patientCcmStatusLogs,
    patientHoldingStatusLogs,
    comments,
    clinics,
    discharge,
    appointment,
    hospitalPrevention,
    clinicalEscalation,
    orderConsumable,
    activity,
    medicare,
    interactiveTime,
    onboardingStatus,
    compliance,
    adherenceLast30Days,
    clinicalMetrics,
    servicePlans,
    connect,
    practiceOverview,
    adminPanelPatients,
    adminPanelUsers,
    adminPanelAgencyDoctors,
    adminPanelClinics,
    covid,
    adminPanelAgencies,
    ccmPatients,
    ccmPatientDetails,
    clinicRunBookLogs,
    ccmInteractiveTime,
    manualInteractiveTime,
  },
});

export default store;
